import { Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import clsx from "clsx";
import parse from "html-react-parser";
import { AppUrl } from "../../config";
import { KeyStringValue, SearchHighlightResults } from "../../interfaces";
import RouterLink from "../RouterLink";
const PREFIX = "BankFindDisruptor";

const classes = {
  root: `${PREFIX}-root`,
  disruptor: `${PREFIX}-disruptor`,
  title: `${PREFIX}-title`,
  MuiButton: `${PREFIX}-MuiButton`,
  toolBar: `${PREFIX}-toolBar`,
};

const Root = styled("div")(() => ({
  [`& .${classes.root}`]: {
    flexGrow: 1,
    width: "100%",
    display: "inline-block",
  },

  [`& .${classes.disruptor}`]: {
    "cursor": "pointer",
    "width": "75%",
    "float": "right",
    "backgroundColor": "#d9e8f6",
    "color": "#1a4480",
    "borderRadius": 5,
    "boxSizing": "border-box",
    "borderWidth": 1,
    "borderStyle": "solid",
    "borderColor": "#1a4480",
    "boxShadow": "none",
    "transition": ".3s ease",
    "&:hover, &:focus-visible": {
      backgroundColor: "#ffffff",
      textDecoration: "none",
      boxShadow: "0px 0px 5px 2px #acc8df",
    },
  },

  [`& .${classes.title}`]: {
    flexGrow: 1,
    fontSize: 16,
  },

  [`& .${classes.MuiButton}`]: {
    "&.MuiButton-root.MuiButton-colorInherit": {
      "border": "none",
      "borderRadius": " 0px 3px 3px 0px",
      "margin": 0,
      "height": 48,
      "backgroundColor": "#1a4480",
      "color": "#ffffff",
      "&:hover": {
        backgroundColor: "#1a4480",
      },
    },
  },

  [`& .${classes.toolBar}`]: {
    "height": 48,
    "min-height": 48,
    "paddingRight": 0,

    "& .MuiTypography-h6": {
      lineHeight: 1.25,
    },
  },
}));

interface Props {
  cert: string;
  searchValue: KeyStringValue | string;
  searchMatches: SearchHighlightResults;
  onClick?: (event?: any) => void;
}

const DisruptorToolTip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#eeeeee",
  },
}));

export default function BankFindDisruptor({
  cert,
  searchValue,
  searchMatches,
}: Props) {
  const parseHtml = (string: string) => {
    const boldString = string
      .replace(/<em>/g, "<b>")
      .replace(/<\/em>/g, "</b>");
    return parse(boldString);
  };

  const BankFindDisruptorToolTip = (
    <>
      {searchMatches.tradeNames.length ? (
        <>
          <Typography variant="h4" style={{ paddingBottom: 0 }}>
            Trade Names
          </Typography>
          {searchMatches.tradeNames.map((tradeName: string, index: number) => (
            <Typography id={`trade-name-${index}`} key={index}>
              {parseHtml(tradeName)}
            </Typography>
          ))}
        </>
      ) : undefined}
      {searchMatches.priorNames.length ? (
        <Typography variant="h4" style={{ paddingBottom: 0 }}>
          Prior Names
          {searchMatches.priorNames.map((priorName: string, index: number) => (
            <Typography id={`prior-name-${index}`} key={index}>
              {parseHtml(priorName)}
            </Typography>
          ))}
        </Typography>
      ) : undefined}
      {/* {searchMatches.websites.length ? (
        <div id={"deposit-accepting-websites"}>
          <Typography variant="h4" style={{ paddingBottom: 0 }}>
            Deposit Accepting Websites
          </Typography>
          {searchMatches.websites.map((website: string, index: number) => (
            <Typography id={`website-${index}`} key={index}>
              {website.replace(/<[^>]*>/g, "")}
            </Typography>
          ))}
        </div>
      ) : (
        undefined
      )} */}
    </>
  );

  return (
    <Root>
      <div className={classes.root}>
        <RouterLink
          buttonLink
          href={`/bankfind/details/${cert}?bankfindLevelThreeView=Other%20Names`}
          currentUrl={AppUrl("BankFind") + window.location.search}
          className={classes.disruptor}
        >
          <Toolbar className={classes.toolBar}>
            <Typography variant="h6" className={classes.title}>
              {`${searchMatches.count} Matches For "${searchValue}"`}
            </Typography>
            <DisruptorToolTip
              arrow
              title={BankFindDisruptorToolTip}
              placement="left"
            >
              <Button
                className={clsx(classes.MuiButton, "disruptor-button")}
                color="inherit"
              >
                View
              </Button>
            </DisruptorToolTip>
          </Toolbar>
        </RouterLink>
      </div>
    </Root>
  );
}
